/**
 * Query keys centralizzate per le query TanStack Query della dashboard HACCP.
 * Usa questa struttura per garantire invalidazione consistente della cache.
 */
export const haccpDashboardQueryKeys = {
  all: ['haccp-dashboard'] as const,
  stats: () => ['haccp-dashboard', 'stats'] as const,
  nonConformities: (from: string, to: string) =>
    ['haccp-dashboard', 'non-conformities', from, to] as const,
};
